
export enum ComponentType {
    AggregateCard = "AggregateCard",
    EventCard = "CardTypes",
    MiniEventCard = "MiniCardTypes",
    MiniOutright = "MiniOutright",
    LiveOutright = "LiveOutright",
    PreLiveOutright = "PreLiveOutright"
}